import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-tootip',
  templateUrl: './tootip.component.html',
  styleUrls: ['./tootip.component.css']
})
export class TootipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
